<template>
  <generic-container
    icon="key"
    :show_plus="true"
    :title="$t('access management')"
    class="ui basic segment"
    @add="add_user"
  >
    <div class="ui form">
      <div class="fields" v-for="(usr, idx) in users" :key="idx">
        <div class="six wide column field">
          <label for>{{ $t("username") }}</label>
          <input type="text" name="username" v-model="users[idx].username" />
        </div>
        <div class="six wide column field">
          <label for>{{ $t("password") }}</label>
          <input type="text" name="password" v-model="users[idx].password" />
        </div>
        <div class="four wide column field">
          <label for>{{ $t("options") }}</label>
          <div class="ui red icon labeled button" @click="remove_user(usr, idx)">
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{users}}</pre> -->
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";
import { isEmpty } from "lodash";

export default {
  name: "BasicAuthentication",
  components: { GenericContainer },
  props: {
    endpoint_in: Object
  },
  computed: {},
  data() {
    return {
      users: []
    };
  },
  methods: {
    getData() {
      return this.users;
    },
    add_user() {
      this.users.push({ uuid: v4(), username: "", password: "" });
    },
    remove_user(user, index) {
      let vm = this;
      vm.users.splice(index, 1);
    }
  },
  mounted() {
    if (!isEmpty(this.endpoint_in)) {
      this.users =
        this.endpoint_in.setup.security.basic_authentication_users || [];
    }
  },
  created() {},
  watch: {},
  updated: function() {}
};
</script>
